import { render } from "./TheFileViewer.vue?vue&type=template&id=42d3f4f9&scoped=true&ts=true"
import script from "./TheFileViewer.vue?vue&type=script&lang=ts"
export * from "./TheFileViewer.vue?vue&type=script&lang=ts"

import "./TheFileViewer.vue?vue&type=style&index=0&id=42d3f4f9&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d3f4f9"]])

export default __exports__